import m from "./../../../dist/es2015/locales/en.js";
export const am5locales_en = m;